import React, { useEffect, useState } from "react";
import Table from "../../components/table/Table";
import Inputs from "../../components/inputs/Inputs";
import MyDialog from "../../components/dialog/Dialog";
import MySpinner from "../../components/Spinner/spinner";
import { getCategory, getUnitMeasures } from "../../app/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { addSideEffects, getSideEffects, updateSideEffects } from "../../app/sideEffectsSlice";
import { addDispodedItems } from "../../app/disposedItemsSlice";
import AppTabs from "../../components/appTabs/appTabs";
import { customerSchema, disposeSchema, hasAccess, instCat, messageSchema, orderSchema, purchaseSchema, saleSchema, scheduleSchema } from "../../common/validators";
import validate from "validate.js";
import { addCustomer, getCustomers, getSmsBalance, purchaseSms, sendSms, updateCustomer } from "../../app/customersSlice";
import { getItems } from "../../app/itemsSlice";
import { addOrder } from "../../app/ordersSlice";
import Messages from "../../components/messages/Messages";
import { addPos } from "../../app/posSlice";
import { toast } from "react-toastify";
import moment from "moment";
import { getSchedulesList, postVisitSchedule } from "../../api/visitSchedulesAPI";
import { getUserList } from "../../api/userAPI";


const tabs = [
  {
    title: "Visit History",
  },
  {
    title: "Feedback History",
  }
];

const itemsTableHead = [
  { label: "Name", name: "customer_name" },
  { label: "Mobile", name: "customer_mobile" },
  // { label: "Email", name: "customer_email" },
  { label: "Alternative Mobile", name: "alt_customer_mobile" },
  { label: "Birth", name: "dob" },
  { label: "Address", name: "address" },
  "action",
];

const genderLov = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" }
]



const isViewAccess = () => {
  return hasAccess('items','view');
}

const isDetailsAccess = () => {
  return hasAccess('customers','details');
}

const isEditAccess = () => {
  return hasAccess('customers','edit');
}

const isAddAccess = () => {
  return hasAccess('customers','add');
}

const isAddStockAccess = () => {
  return hasAccess('orders','add');
}

const isEditStockAccess = () => {
  return hasAccess('orders','edit');
}

const isDisposeAccess = () => {
  return hasAccess('customers','delete');
}

const Customers = () => {
  let [openForm, setOpenForm] = useState(false);
  let [openStockForm, setOpenStockForm] = useState(false);
  let [toSell, setToSell] = useState(false);  
  let [openDisposeForm, setOpenDisposeForm] = useState(false);
  let [openDetail, setOpenDetail] = useState(false);
  let [edit, setEdit] = useState(false);
  let [viewDetailsSelected, setViewDetailsSelected] = useState(false);
  let [hideSaveButton, setHideSaveButton] = useState(false);
  let [showSideEffect, setShowSideEffect] = useState(false);
  let [toEditSideEffect, setToEditSideEffect] = useState(false);
  const [errors, setErrors] = useState([]);
  const [totalPurchaseAmount, setTotalPurchaseAmount] = useState(0);  
  const [formValues, setFormValues] = useState({"visit_date": new Date()});
  const [selectedItem, setSelectedItem] = useState({});
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [itemDataList, setItemDataList] = useState([]);
  const [OfficersList, setOfficersList] = useState([]);
  
  const [measuresDataList, setMeasuresDataList] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  let [openSms, setOpenSms] = useState(false);
  let [isPurchase, setIsPurchase] = useState(false);
  let [isLoading, setIsLoading] = useState(false);
  


  const dispatch = useDispatch();

  const { error, status, list } = useSelector(
    ({ customers }) => customers.get
  );

  const { error: postError, status: postStatus } = useSelector(
    ({ customers }) => customers.post
  );

  const { error: putError, status: putStatus } = useSelector(
    ({ customers }) => customers.put
  );

  const { error: errorItems, status: statusItems, list: listItems } = useSelector(
    ({ items }) => items.get
  );

  const { error: postOrderError, status: postOrderStatus } = useSelector(
    ({ orders }) => orders.post
  );

  const { error: saleErrorPost, status: saleStatusPost } = useSelector(
    ({ pos }) => pos.post
  );
 
  const { error: postDisposeError, status: postDisposeStatus } = useSelector(
    ({ disposedItems }) => disposedItems.post
  );

  const { error: postSideEffectsError, status: postSideEffectsStatus } = useSelector(
    ({ sideEffects }) => sideEffects.post
  );

  const { error: putSideEffectsError, status: putSideEffectsStatus } = useSelector(
    ({ sideEffects }) => sideEffects.put
  );

  const { error: smsError, status: smsStatus, list: smsList } = useSelector(
    ({ customers }) => customers.smsSend
  );

  const { error: purchaseError, status: purchaseStatus, list: purchaseList } = useSelector(
    ({ customers }) => customers.smsPurchase
  );

  const { error: balanceError, status: balanceStatus, list: balanceList } = useSelector(
    ({ customers }) => customers.smsBalance
  );

  const loadBalance = () => {
    dispatch(getSmsBalance());
  }

  const handleRequestClose = () => {
    setErrors([])
    setFormValues({});
    setOpenForm(false);
    setOpenDetail(false);
    setOpenStockForm(false);
    setToSell(false);
    setOpenDisposeForm(false);
    setShowSideEffect(false);
    setEdit(false);
    setToEditSideEffect(false);
    setActiveTab(0);
    setSelectedOrders([]);
    setTotalPrice(0);
    setFormValues({})
  };

  const loadSmsDialog = () => {
    loadBalance()
    setOpenSms(!openSms);
    setIsPurchase(false)
    setTotalPurchaseAmount(0)
  }

  const handleSendSms = (e) => {
    setIsLoading(true)
    e.preventDefault();
    //console.log('smsFormValues',formValues)
    if(isPurchase === true){
      let validationErrors = validate(
        formValues,
        purchaseSchema
      );
      if(validationErrors){
        setErrors(validationErrors);      
      }else{
        dispatch(purchaseSms(formValues)) 
      }      
    }else{
      let newFormValues = {
        ...formValues,
        group: formValues?.receiversGroup,
        message: formValues?.messageBody
      }
      let validationErrors = validate(
        formValues,
        messageSchema
      );
      if(validationErrors){
        setErrors(validationErrors);      
      }else{  
        dispatch(sendSms(newFormValues))  
      }
    }
      
  }



  const viewItem = (item) => {
    if (item) {

      setViewDetailsSelected(true)

      setEdit(false);
      setOpenDisposeForm(false);
      setFormValues(item);
      setSelectedItem(item);
      setTimeout(() => {
        setOpenDetail(true);
      }, 300);
    }
  };

  const editItem = (item) => {
    if (item) {
      setEdit(true);
      setOpenDisposeForm(false);
      setFormValues(item);
      setSelectedItem(item);
      setTimeout(() => {
        setOpenForm(true);
      }, 300);
    }
  };

 

  const formOpen = () => {
    return (
      <>
        <div className="row">
          <div className="col-sm-12 col-md-6 col-6">
            <Inputs
              name="customer_name"
              size="small"
              label="Name of Patient"
              value={formValues.customer_name}
              inputType="text"
              disabled={edit ? true : false}
              onChange={handleChange}
              error={errors["customer_name"] ? true : false}
              helperText={errors["customer_name"] ? errors.customer_name[0] : null}
            />
          </div>
          <div className="col-sm-12 col-md-6 col-6">
            <Inputs
              name="customer_mobile"
              size="small"
              label="Mobile Number"
              value={formValues.customer_mobile}
              inputType="number"
              onChange={handleChange}
              error={errors["customer_mobile"] ? true : false}
              helperText={errors["customer_mobile"] ? errors.customer_mobile[0] : null}
            />
          </div>
          <div className="col-sm-12 col-md-6 col-6">
            <Inputs
              name="customer_email"
              size="small"
              label="Email Address"
              value={formValues.customer_email}
              inputType="text"
              onChange={handleChange}
              error={errors["customer_email"] ? true : false}
              helperText={errors["customer_email"] ? errors.customer_email[0] : null}
            />
          </div>
          <div className="col-sm-12 col-md-6 col-6">
            <Inputs
              name="alt_customer_mobile"
              size="small"
              label="Alternative Mobile Number"
              value={formValues.alt_customer_mobile}
              inputType="number"
              onChange={handleChange}
              error={errors["alt_customer_mobile"] ? true : false}
              helperText={errors["alt_customer_mobile"] ? errors.alt_customer_mobile[0] : null}
            />
          </div>
          <div className="col-sm-12 col-md-6 col-6">
            <Inputs
              name="address"
              size="small"
              label="Physical Address"
              value={formValues.address}
              inputType="text"
              //disabled={edit ? true : false}
              onChange={handleChange}
              error={errors["address"] ? true : false}
              helperText={errors["address"] ? errors.address[0] : null}
            />
          </div>

          <div className="col-sm-12 col-md-6 col-6">
            <Inputs
              name="gender"
              size="small"
              label="Gender"
              inputType="select"
              defaultValue={genderLov[0]["value"]}
              value={formValues?.gender ?? genderLov[0]["value"]}
              listLabel="Gender"
              listValue="gender"
              list={genderLov}
              onChange={handleChange}
              error={errors["gender"] ? true : false}
              helperText={errors["gender"] ? errors.gender[0] : null}
            />
          </div>

          <div className="col-sm-12 col-md-6 col-6">
            <Inputs
              name="dob"
              size="small"
              label="Date of Birth"
              value={formValues.dob}
              inputType="date"
              //disabled={edit ? true : false}
              onChange={(e) => {handleChange({ target: { name: "dob", value: e } })}}
              error={errors["dob"] ? true : false}
              helperText={errors["dob"] ? errors.dob[0] : null}
            />
          </div>

          
          <div className="col-sm-12 col-md-6 col-6">
            <Inputs
              name="remarks"
              size="small"
              label="Other Remarks"
              value={formValues.remarks}
              inputType="text"          // keep if your wrapper ignores type when multiline=true
              multiline={true}                 // <-- make it a textarea
              minRows={3}               // or rows={4}
              onChange={handleChange}
              error={!!errors["remarks"]}
              helperText={errors["remarks"] ? errors.remarks[0] : null}
            />
          </div>


        </div>
      </>
    );
  };

  const formVisitSchedule = (item,isSale = false) => {
    return (
      <>
        <div className="row">
          <div className="col-sm-12 col-md-6 col-6">
            <Inputs
              name="service_id"
              size="small"
              inputType="select"
              value={formValues.service_id}
              defaultValue={{value:'retail',label:'Retail'}}
              label="Service Category"
              listLabel="Service Category"
              listValue="service_id"
              list={[{value:1,label:'Physiotherapy'},{value:2,label:'Home Nursing'}]}
              onChange={handleChange}
              error={errors["service_id"] ? true : false}
              helperText={errors["service_id"] ? errors.service_id[0] : null}
            />
          </div>
          <div className="col-sm-12 col-md-6 col-6">
            <Inputs
              name="visit_date"
              size="small"
              label="Visit Date"
              value={formValues.visit_date}
              inputType="date"
              onChange={(e) =>
              handleChange({ target: { name: "visit_date", value: e } })}
              error={errors["visit_date"] ? true : false}
              helperText={errors["visit_date"] ? errors.visit_date[0] : null}
            />
          </div>
          <div className="col-sm-12 col-md-6 col-6">
            <Inputs
              name="pay_type"
              size="small"
              inputType="select"
              value={formValues.pay_type}
              defaultValue={{value:'cash',label:'Cash'}}
              label="Pay Type"
              listLabel="Pay Type"
              listValue="pay_type"
              list={[{value:'cash',label:'Cash'},{value:'transfer',label:'Transfer'},{value:'none',label:'Not Paid'}]}
              onChange={handleChange}
              error={errors["pay_type"] ? true : false}
              helperText={errors["pay_type"] ? errors.pay_type[0] : null}
            />
          </div>
          <div className="col-sm-12 col-md-6 col-6">
            <Inputs
              name="attendant_id"
              size="small"
              inputType="select"
              value={formValues.attendant_id}
              defaultValue={{value:1,label:'Test Officer'}}
              label="Leading Officer"
              listLabel="Leading Officer"
              listValue="attendant_id"
              list={OfficersList}
              // list={[{value:1,label:'Test Officer'}]}
              onChange={handleChange}
              error={errors["attendant_id"] ? true : false}
              helperText={errors["attendant_id"] ? errors.attendant_id[0] : null}
            />
          </div>
          
          <div className="col-sm-12 col-md-12 col-12">
            <Inputs
              name="remarks"
              size="small"
              label="Other Remarks"
              value={formValues.remarks}
              inputType="text"          // keep if your wrapper ignores type when multiline=true
              multiline={true}                 // <-- make it a textarea
              minRows={3} 
              onChange={handleChange}
              error={!!errors["remarks"]}
              helperText={errors["remarks"] ? errors.remarks[0] : null}
            />
          </div>
         

        </div>
      </>
    );
  };


  const dialogOpen = () => {
    return (
      <>
        <div className="row">
          <div className="col-sm-12 col-md-6 col-6">
            <span>Name: </span>&nbsp;&nbsp;
            <span>{selectedItem?.customer_name}</span>
          </div>
          <div className="col-sm-12 col-md-6 col-6">
            <span>Mobile: </span>&nbsp;&nbsp;
            <span>{selectedItem?.customer_mobile}</span>
          </div>
          <div className="col-sm-12 col-md-6 col-6">
            <span>Email: </span>&nbsp;&nbsp;
            <span>{selectedItem?.customer_email}</span>
          </div>
          <div className="col-sm-12 col-md-6 col-6">
            <span>Alternative Mobile: </span>&nbsp;&nbsp;
            <span>{selectedItem?.alt_customer_mobile}</span>
          </div>

          <div className="col-sm-12 col-md-6 col-6">
            <span>Birth: </span>&nbsp;&nbsp;
            <span>{moment(selectedItem?.dob).format('YYYY-MM-DD')} ({moment().diff(moment(selectedItem?.dob), "years")})</span>
          </div>

          <div className="col-sm-12 col-md-6 col-6">
            <span>Address: </span>&nbsp;&nbsp;
            <span>{selectedItem?.address}</span>
          </div>

          <div className="col-sm-12 col-md-12 col-12">
            <span>Remarks: </span>&nbsp;&nbsp;
            <span>{selectedItem?.remarks}</span>
          </div>

          <br /> <br />
          <div className="col-sm-12 col-md-12 col-12">
          <AppTabs
            tabs={tabs}
            activeTab={activeTab}
            handleTabChange={handleChangeTabs}
          />
          </div>
          <br /> <br />


        </div>
      </>
    );
  };

  
  const handleChangePurchase = (event) => {
    //alert(event.target.checked)
    setIsPurchase(!isPurchase);
    // setIsPurchase(event.target.checked);
  };


  const handleChangeOnSMSForm = (event) => {    
    //alert(JSON.stringify(event.target))
    setFormValues({
      ...formValues,
      [event.target.name]:
        event.target.type === "checkbox"
          ? event.target.checked
          : event.target.value,
    });
  };

  const handleChange = (event) => {
   
    //alert(JSON.stringify(event.target.value))
    setFormValues({
      ...formValues,
      [event.target.name]:
        event.target.type === "checkbox"
          ? event.target.checked
          : event.target.value,
    });

    
    if(event.target.name === "unit_of_measure"){
       setFormValues({
        ...formValues,
        "rate": formValues.sale_category === 'wholesale' ? event.target.value["w_selling_price"] : event.target.value["selling_price"],
        "item_code": event.target.value["item_code"],
        "item_id": event.target.value["id"],
        "item_description": event.target.value["item_description"],
        "counts":1
      });

      
    }
  };

  const addToOrderList = () => {

        //alert(JSON.stringify(formValues))

        let _selectedOrders = selectedOrders;      
        let selectedOrder = {"customer_id":selectedItem["id"],"order_date":formValues["order_date"],"deliver_date":formValues["deliver_date"],"item_id":null,"item_code":null,"item_description":null,"counts":0,"amount":0}
    
        selectedOrder.amount = formValues.counts * formValues.rate;
        selectedOrder.counts = formValues.counts;
        selectedOrder.item_code = formValues["item_code"];
        selectedOrder.item_id = formValues["item_id"];
        selectedOrder.item_description = formValues["item_description"];

        const itemPresent = _selectedOrders.filter((item) => item.item_code !== selectedOrder.item_code);
        // const itemPresent = _selectedOrders.find((item) => item.item_code === selectedOrder.item_code);
        _selectedOrders = itemPresent;
        if (itemPresent) {         
          _selectedOrders.push(selectedOrder);
          setSelectedOrders(_selectedOrders);

          if(formValues.counts > 0 && !_selectedOrders.includes(selectedOrder)){
            _selectedOrders.push(selectedOrder);
            setSelectedOrders(_selectedOrders);
          }
        }

        calculateTotalPrice(itemPresent);
  }

  const calculateTotalPrice = (itemPresent) => {
    let totalAmount = 0;
    for (let index = 0; index < itemPresent.length; index++) {
      totalAmount = totalAmount + itemPresent[index]["amount"];      
    }

    setTotalPrice(totalAmount);
  }

  const handleSubmitSale = (itemsPurchasedList = [], totalAmount = 0) => {
    if (itemsPurchasedList.length > 0) {
      if (formValues.sell_type == "oncredit") {
        let newSale = {
          taiData: itemsPurchasedList,
          payType: formValues.sell_type,
          customerName: selectedItem?.customer_name,
          customerMobile: selectedItem?.customer_mobile,
          totalAmount: totalAmount,
          sellingDate: formValues.order_date
        }
        dispatch(addPos(newSale))
      } else if (instCat() != 4 && formValues.sell_type === "cash") {
        let newSale = {
          taiData: itemsPurchasedList,
          customerName: selectedItem?.customer_name,
          customerMobile: selectedItem?.customer_mobile,
          sellingDate: formValues.order_date
        }
        dispatch(addPos(newSale))
      } else {
        toast.error("Please provide customer name and mobile number");
      }

    } else {
      toast.error("Please provide Items");
    }

  };

  const handleSubmitSchedule = async (e) => {
    e.preventDefault();
    let validationErrors = validate(
      formValues,
      scheduleSchema      
    );
    if(validationErrors){
      //alert(JSON.stringify(formValues))
      setErrors(validationErrors);      
    }else{
      // alert(JSON.stringify(formValues))
      setHideSaveButton(true)
      let schedules = await postVisitSchedule(formValues);
      // console.log('schedules',schedules)
      //alert(1)
      setHideSaveButton(false)
      if(schedules.data.mode === 'success'){
        toast.success(schedules.data.message ?? "Successful", {
          autoClose: 2600,
          hideProgressBar: true,
        });
      }else{
        toast.error(schedules.data.message ?? "Request has failed", {
          autoClose: 2600,
          hideProgressBar: true,
        });
      }
      setOpenStockForm(false)
    }
  
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    //toast.success(JSON.stringify(formValues));
    if (edit && !openStockForm) {
      let validationErrors = validate(
        formValues,
        customerSchema
      );
      if(validationErrors){
        setErrors(validationErrors);      
      }else{
      let newItem = {
        "id": formValues?.id,
        "customer_name": formValues?.customer_name,
        "customer_mobile": formValues?.customer_mobile,
        "customer_email": formValues?.customer_email,
        "tin": formValues?.tin,
        "dob": formValues?.dob,
        "alt_customer_mobile": formValues?.alt_customer_mobile,
        "address": formValues?.address,
        "gender": formValues?.gender,
        "remarks": formValues?.remarks,
      }
      dispatch(updateCustomer(newItem));
    }
    } else if (openStockForm && toSell === false) {
      let validationErrors = validate(
        formValues,
        orderSchema
        
      );
      if(validationErrors){
        setErrors(validationErrors);      
      }else{
        //toast.success(JSON.stringify(formValues));
        for (let index = 0; index < selectedOrders.length; index++) {
          delete selectedOrders[index]['item_code'];
          delete selectedOrders[index]['item_description'];        
        }      
        dispatch(addOrder({toSend:JSON.stringify(selectedOrders)}))
      }
    }else if (openStockForm && toSell === true) {
      let validationErrors = validate(
        formValues,
        saleSchema
      );
      if(validationErrors){
        setErrors(validationErrors);      
      }else{
        //toast.success(JSON.stringify(formValues));
        let _selectedOrders = selectedOrders;
        let totalAmountSale = 0;
        for (let index = 0; index < _selectedOrders.length; index++) {
          totalAmountSale = totalAmountSale + _selectedOrders[index]['amount'];
          _selectedOrders[index]['rate'] = _selectedOrders[index]['amount']/_selectedOrders[index]['counts']
          _selectedOrders[index]['qty'] = _selectedOrders[index]['counts']
          _selectedOrders[index]['is_retail'] = formValues?.sale_category === 'retail' ? 'Y' : 'N'
          _selectedOrders[index]['discount'] = 0
          _selectedOrders[index]['package'] = ''
          _selectedOrders[index]['unit_of_measure'] = ''
          
          delete _selectedOrders[index]['order_date'];
          delete _selectedOrders[index]['deliver_date'];    
          delete _selectedOrders[index]['customer_id'];    
          delete _selectedOrders[index]['counts'];    
              
        }    
        handleSubmitSale(_selectedOrders,totalAmountSale);
      }

    } else if (openDisposeForm) {
      let validationErrors = validate(
        formValues,
        disposeSchema
      );
      if(validationErrors){
        //console.log('validationErrors',validationErrors)
        setErrors(validationErrors);      
      }else{
      setFormValues({
        ...formValues,
        item_id: selectedItem?.id
      })
      //alert(JSON.stringify(formValues))
      dispatch(addDispodedItems(formValues))
    }
    }else if(showSideEffect && !toEditSideEffect){
      let newEffect = {
        item_code:formValues.item_code,
        item_id:formValues.id,
        remarks:formValues.side_effect,
        status:'A'
      }
      // alert(JSON.stringify(newEffect))
      dispatch(addSideEffects(newEffect))
    } else if(showSideEffect && toEditSideEffect){
      let newEffect = {
        id:formValues.id,
        item_code:formValues.item_code,
        item_id:formValues.item_id,
        remarks:formValues.side_effect,
        status:String(formValues.side_effect).length < 5 ? 'X' : 'A'
      }
      // alert(JSON.stringify(newEffect))
      dispatch(updateSideEffects(newEffect))
    }
     else {
      let validationErrors = validate(
        formValues,
        customerSchema
      );
      if(validationErrors){
        setErrors(validationErrors);      
      }else{
      let newItem = {
        "customer_name": formValues?.customer_name,
        "customer_mobile": formValues?.customer_mobile,
        "customer_email": formValues?.customer_email,
        "tin": formValues?.tin,
        "dob": formValues?.dob,
        "alt_customer_mobile": formValues?.alt_customer_mobile,
        "address": formValues?.address,
        "gender": formValues?.gender,
        "remarks": formValues?.remarks,
      }
      dispatch(addCustomer(newItem));
    }
    }

  };


  const newStockClicked = (item = null, _toSell = false) => {
    // e.preventDefault();
    //toast.success("New Stock");
    // dispatch(getItems())
    //setFormValues({ item_code: item?.item_code, item_description: item?.item_description, buy_date: new Date() })
    setSelectedItem(item);
    setOpenStockForm(true);
    setToSell(_toSell);
    setOpenDisposeForm(false);


  };

  const disposeClicked = (item = null) => {
    //setFormValues({ item_code: item?.item_code, item_description: item?.item_description, destroy_date: new Date() })
    setSelectedItem(item);
    setOpenDisposeForm(true);
    setEdit(false);
    setOpenDetail(false);

  };

  const handleChangeTabs = (index) => {
    setActiveTab(index);
  };

  const loadOfficers = async () => {
    let officers = await getUserList();
    if(officers.data){
      let arr = [];
       for (let index = 0; index < officers.data.length; index++) {
        const element = officers.data[index];
        let obj = {value: element.id, label: element?.f_name+' '+element?.f_name+' '+element?.l_name}
        arr.push(obj)
       }
       setOfficersList(arr)
    }
    return true
  }


  useEffect(() => {
    dispatch(getCustomers());
    dispatch(getCategory());
    dispatch(getUnitMeasures());
  }, [dispatch]);


  useEffect(() => {
    setToEditSideEffect(false);
    if (activeTab === 0) {
      setShowSideEffect(false);
      if (viewDetailsSelected === true && selectedItem) {
        //dispatch(getStockHistory({ item_code: selectedItem?.item_code }))
      }
      // dispatch(getExpenses())
    } else {
      //setShowStock(false);
      setShowSideEffect(false);
    }

  }, [activeTab]);

  useEffect(() => {
    if (selectedItem) {
      
      loadOfficers()
      let newValues = {
        ...formValues,
        "customer_id": selectedItem?.id
        }  
        setFormValues(newValues)
    }
  }, [selectedItem]);



  useEffect(() => {
    if (postStatus === "loading" && !edit) {
      setHideSaveButton(true);
    } else if (postStatus === "idle") {
      dispatch(getCustomers());
      setHideSaveButton(false);
    }
  }, [postStatus]);

  useEffect(() => {
    if (smsStatus === "loading") {
      setOpenSms(true);
    } else if (smsError === null && smsStatus === "idle") {
      setOpenSms(false);
    }
  }, [smsStatus,smsError]);

  useEffect(() => {
    if (purchaseStatus === "loading") {
      setOpenSms(true);
    } else if (purchaseError === null && purchaseStatus === "idle") {
      setIsPurchase(false);
      setOpenSms(false);
    }
  }, [purchaseStatus,purchaseError]);

  

  

  useEffect(() => {
    if (postSideEffectsStatus === "loading" && showSideEffect) {
      setHideSaveButton(true);
    } else if (postSideEffectsStatus === "idle") {
      dispatch(getSideEffects({item_code:selectedItem?.item_code}));
      setHideSaveButton(false);
    }
  }, [postSideEffectsStatus]);


  useEffect(() => {
    if (putSideEffectsStatus === "loading" && showSideEffect) {
      setHideSaveButton(true);
    } else if (putSideEffectsStatus === "idle") {
      //setToEditSideEffect(false);
      dispatch(getSideEffects({item_code:selectedItem?.item_code}));
      setHideSaveButton(false);
    }
  }, [putSideEffectsStatus]);

  

  useEffect(() => {
    if (postDisposeStatus === "loading") {
      setHideSaveButton(true);
    } else if (postDisposeStatus === "idle") {
      dispatch(getCustomers());
      setHideSaveButton(false);
    }
  }, [postDisposeStatus]);

  useEffect(() => {
    if (putStatus === "loading" && edit) {
      setHideSaveButton(true);
    } else if (putStatus === "idle") {
      dispatch(getCustomers());
      setHideSaveButton(false);
    }

  }, [putStatus]);

  useEffect(() => {
    if (postOrderStatus === "loading") {
      setHideSaveButton(true);
    } else if (postOrderStatus === "idle") {
      dispatch(getCustomers());
      setHideSaveButton(false);
      setTotalPrice(0);
      setSelectedOrders([]);
      setFormValues({})
    }
  }, [postOrderStatus]);

  useEffect(() => {
    if (saleStatusPost === "loading") {
      setHideSaveButton(true);
    } else if (saleStatusPost === "posted") {
      dispatch(getCustomers());
      setHideSaveButton(false);
      setTotalPrice(0);
      setSelectedOrders([]);
      setFormValues({})
      // setToSell(false)
    }
  }, [saleStatusPost,saleErrorPost]);
  

  useEffect(() => {
    if (status === "loading") {
      setIsLoading(true)
    } else if (status === "idle") {
      setIsLoading(false)
      let patientsList = [];
      for (let index = 0; index < list.length; index++) {
        let element = list[index];
        let newElement = {
          ...element,
          dob: moment(element?.dob).format('YYYY-MM-DD')
        }        
        patientsList.push(newElement)
      }
      setItemDataList(patientsList);
    }
  }, [status, list]);


  useEffect(() => {
    if (postOrderError) {
      setOpenStockForm(true);
    } else if (postOrderStatus === "idle") {
      setOpenStockForm(false)
      setToSell(false)
      setTotalPrice(0);
      setSelectedOrders([]);
      setFormValues({})
    }


  }, [postOrderStatus, postOrderError]);


  useEffect(() => {
    if (statusItems === "loading") {

    } else if (statusItems === "idle") {
      let measureArray = [];
      for (let index = 0; index < listItems.length; index++) {
        measureArray.push({ value: listItems[index], label: listItems[index]?.item_description })
      }
      setMeasuresDataList(measureArray);
    }
  }, [statusItems, listItems]);


  return (
    <div>
      <div className="ez-page-action">
        <h2 className="page-header">Registered Patients</h2>
        {/* <i
          title="New Item"
          className={`bx bx-plus bx-burst-hover`}
          style={{color:"red",cursor:"pointer"}}
          onClick={() => {
            setOpenForm(true);
          }}
        ></i> */}
        &nbsp;
        <div style={{ alignContent: "right" }}>
          {isAddAccess &&
          <Inputs
            color="success"
            className={`bx-burst-hover`}
            size="small"
            inputType="button"
            type="submit"
            text={"New Patient"}
            onClick={() => setOpenForm(true)}
            propBackgroundColor={"#367588"}
          />
          }
          &nbsp;
          {isAddAccess &&
          <Inputs
            color="success"
            className={`bx-burst-hover`}
            size="small"
            inputType="button"
            type="submit"
            text={"New Message"}
            onClick={() => loadSmsDialog()}
            propBackgroundColor={"#800000ff"}
          />
          }
          {/* <Inputs
          color="info"
          size="small"
          inputType="button"
          type="submit"
          text={"New Stock"}
          onClick={() => newStockClicked()}
        /> */}
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card" style={{ backgroundColor: "#e0e0e0" }}>
            <div className="card-body">
              {status === 'idle' ? (
                <Table
                  columns={itemsTableHead}
                  data={itemDataList}
                  actions={[
                    {
                      action: "Details",
                      renderCheck: isDetailsAccess,
                      onClick: (item) => {
                        viewItem(item);
                      },
                    },
                    {
                      action: "Update",
                      renderCheck: isEditAccess,
                      onClick: (item) => {
                        editItem(item);
                      },
                    },
                    {
                      action: "Schedule Visit",
                      renderCheck: isAddStockAccess,
                      onClick: (item) => {
                        newStockClicked(item);
                      },
                    },
                  ]}
                  downloadFileName={"Registered Patients"}
                />
              ) : (
                <MySpinner size={35} color="#367588" />
              )}
            </div>
          </div>
        </div>
      </div>

      <MyDialog
        title={(isPurchase === true ? "Purchasing Messages" : "Sending Message")+(balanceList && balanceList.length>0? ' - Available balance '+Number(balanceList[0]['counts']).toLocaleString()+' ' : '')}
        width="sm"
        onClose={loadSmsDialog}
        open={openSms}
        text={isPurchase === true ? "Request Invoice" : "Send Message"}
        content={() => <Messages handleChangeSMS={handleChangeOnSMSForm} handleChangePurchase={handleChangePurchase} setFormValues={setFormValues} isPurchase={isPurchase} totalPurchaseAmount={totalPurchaseAmount} />}
        submit={(e) => handleSendSms(e)}
        hideSaveButton={openSms && !(purchaseStatus === 'loading' || smsStatus === 'loading') ? false: true}
        propBackgroundColor="#367588"
      />

      <MyDialog
        title={"Patient Details"}
        width="md"
        onClose={handleRequestClose}
        open={openDetail}
        text={showSideEffect ? "Save Side Effect" : "Update"}
        content={() => dialogOpen()}
        submit={(e) => handleSubmit(e)}
        hideSaveButton={showSideEffect ? false: true}
        propBackgroundColor="#367588"
      />

      <MyDialog
        title={!edit ? "New Patient Details" :"Update Patient Details"}
        width="md"
        onClose={handleRequestClose}
        open={openForm}
        text={!edit ? "Save" : "Update"}
        content={() => formOpen()}
        submit={(e) => handleSubmit(e)}
        hideSaveButton={hideSaveButton}
        propBackgroundColor="#367588"
      />

      <MyDialog
        title={"Visit Schedule for "+String(selectedItem?.customer_name).toUpperCase()+" "+selectedItem?.customer_mobile}
        width="sm"
        onClose={handleRequestClose}
        open={openStockForm}
        text={"Save"}
        content={() =>
          formVisitSchedule(selectedItem && selectedItem.id ? selectedItem : null, toSell)
        }
        submit={async (e) => await handleSubmitSchedule(e)}
        hideSaveButton={hideSaveButton}
        propBackgroundColor={"#367588"}
      />
    </div>
  );
};

export default Customers;
